import { CommonModule } from '@angular/common';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { UserProfileComponent } from '../core/components/user-profile/user-profile.component';
import { SharedModule } from '../shared/shared.module';
import { ActivateAccountComponent } from './components/activate-account/activate-account.component';
import { CheckYourEmailComponent } from './components/check-your-email/check-your-email.component';
import { PwdResetRequestComponent } from './components/pwd-reset-request/pwd-reset-request';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { SigninComponent } from './components/signin/signin.component';
import { SignupComponent } from './components/singup/signup.component';
import { WeakPasswordDialogComponent } from './components/weak-password-dialog/weak-password-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    SharedModule,
    SigninComponent,
    SignupComponent,
    UserProfileComponent,
    WeakPasswordDialogComponent,
    ActivateAccountComponent,
    CheckYourEmailComponent,
    PwdResetRequestComponent,
    ResetPasswordComponent,
  ],
  providers: [provideHttpClient(withInterceptorsFromDi(), withFetch())],
})
export class AuthModule {}
